<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <v-card v-if="!isLoading" class="mx-4 mt-4">
    <v-row>
      <v-col>
        <v-card-title class="font-weight-bold">
          {{ this.projeto }}
        </v-card-title>
        <div class="text-h5 ml-4">
          {{ requisito.identificacao }}
        </div>
        <!-- <v-card-title class="font-weight-bold">
          {{ requisito.identificacao }}
        </v-card-title> -->
      </v-col>

      <v-col cols="6">
        <v-card-actions class="d-flex justify-end">
          <div class="d-flex align-center">
            <modal-editar-requisito
              v-if="isDev"
              @requisito-editado="
                (newId) => {
                  this.reqID = newId;
                }
              "
              @rascunho-salvo="getRequisito"
              :tipo-b="true"
              :requisito="requisito"
            >
            </modal-editar-requisito>

            <v-btn
              v-if="isDev"
              class="ml-6"
              variant="text"
              color="error"
              @click="showDialog = true"
              append-icon="mdi-delete-outline"
            >
              Excluir
            </v-btn>
          </div>
        </v-card-actions>
      </v-col>
    </v-row>

    <div class="ml-4 text-subtitle-2 mt-1 mb-2">
      <span>
        Tipo:
        <span class="text-black ml-2 mr-3 font-weight-bold">{{
          converterEnumParaTexto(this.requisito.tipo_requisito)
        }}</span>
      </span>
      <span>
        Criado em:
        <span class="text-black ml-2 mr-3">{{
          new Date(this.requisito.dt_cadastro).toLocaleDateString('pt-br')
        }}</span>
      </span>
    </div>
    <div class="mt-3 mx-4">
      <div class="mt-1 mb-2 text-light-blue-darken-4">Descrição</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ requisito.descricao }}</p>
      </div>
      <div class="mt-1 mb-2 text-light-blue-darken-4">Observação</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ requisito.observacao }}</p>
      </div>
      <div>
        <div class="mt-1 mb-2 text-light-blue-darken-4">
          <div class="d-flex">
            Fonte do Requisito
            <FonteRequisito
              v-if="isDev"
              @fonte-alterada="getFonte"
              class="ml-2"
              :id="this.reqID"
            />
          </div>
        </div>
      </div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">
          Fonte {{ tipoFonte.toLocaleLowerCase() }}{{ fonteNome }}
        </p>
      </div>
    </div>
    <div class="bg-light-blue-darken-4 my-4 mydivider mx-4"></div>
    <!-- <v-card-text class="mt-6">
      <v-row class="mb-2">
        <span class="text-h6 ml-3 my-4 mb-4 mr-4">Fonte do Requisito</span>
        <FonteRequisito
          v-if="isDev"
          @fonte-alterada="getFonte"
          class="ml-4 mt-5"
          :id="this.reqID"
        />
      </v-row>
      <div class="ml-2">Fonte {{ tipoFonte }} {{ fonteNome }}</div>
    </v-card-text> -->

    <v-row class="ml-0" align-content="center">
      <v-card-title class="font-weight-bold"
        >Este requisito depende dos seguintes requisitos:
      </v-card-title>
    </v-row>
    <DependenciasMapReq :id="this.reqID" />

    <HistoricoReq :key="keyHistorico" :reqID="reqID"></HistoricoReq>
  </v-card>

  <dependencia-req
    :conteudo-modal-dep="conteudoModalDep"
    :toggle-show-dialog-dep="toggleShowDialogDep"
    :dialog-dep="showDialogDep"
  />

  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title class="headline"> Confirmação de Remoção </v-card-title>

      <v-card-text>
        Você tem certeza que deseja remover este requisito?
      </v-card-text>

      <v-card-actions>
        <v-btn color="red darken-1" dark @click="deleteRequisito">Sim</v-btn>
        <v-btn color="blue darken-1" dark @click="showDialog = false">
          Não
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container
    v-if="this.isLoading"
    class="mt-5 d-flex justify-center align-center"
  >
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module RequisitoTela
 * @desc Tela que mostra os detalhes relativos a um requisito.
 * @vue-data {Boolean} [showDialog=false] Flag que determina se o modal de
 * remoção de requisito está visível
 * @vue-data {Object} [requisito=null] Objeto que representa o requisito
 * @vue-data {Boolean} [isLoading=true] Flag que indica se o requisito já
 * foi carregado
 * @vue-data {Boolean} [showDialogDep=false] Flag que indica se o modal
 * que mostra detalhes da dependência está visível
 * @vue-data {Object} [conteudoModalDep=null] Objeto com o conteúdo do
 * modal que mostra detalhes da dependência
 * @vue-data {Number} [reqID=0] Id do requisito
 * @vue-data {Number} [projetoID=null] - Armazena o id do projeto
 * @vue-data {String} [projeto=''] - Nome do projeto
 * @vue-data {Object} [fonteRequisito={}] - Objeto que guarda informações
 * sobre a fontes do requisito
 * @vue-data {String} [fonteNome=''] - Nome da fonte.
 * @vue-data {String} tipoFonte - Tipo da fonte (Externa ou Esquipe)
 * @vue-data {Number} [keyHistorico=0] - Chave para atualizar o componente
 * de histórico
 * @vue-computed {Boolean} isDev - Flag que indica se o usuário
 * atual é desenvolvedor no projeto
 */
import axios from 'axios';

import DependenciasMapReq from '@/components/DependenciasMapReq.vue';
import DependenciaReq from '@/components/dialogs/DependenciaReq.vue';
import FonteRequisito from '@/components/dialogs/FonteRequisito.vue';
import ModalEditarRequisito from '@/components/dialogs/ModalEditarRequisito.vue';
import HistoricoReq from '@/components/HistoricoReq.vue';
import store from '@/store/store';

export default {
  name: 'RequisitoTela',
  components: {
    ModalEditarRequisito,
    DependenciaReq,
    HistoricoReq,
    FonteRequisito,
    DependenciasMapReq,
  },
  data() {
    return {
      showDialog: false,
      requisito: null,
      isLoading: true,
      showDialogDep: false,
      conteudoModalDep: null,
      reqID: 0,
      projetoID: null,
      projeto: '',
      fonteRequisito: {},
      fonteNome: '',
      tipoFonte: 'ainda não adicionada.',
      keyHistorico: 0,
    };
  },
  watch: {
    reqID(newReqID, oldReqID) {
      // Se não for a primeira vez que o componente é carregado
      if (oldReqID !== 0) {
        this.getRequisito();
        this.getFonte();
        this.keyHistorico += 1;
      }
    },
  },
  created() {
    this.projetoID = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.reqID = Number(this.$route.params.id);
    this.getRequisito();
    this.getFonte();
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
    isDisabled() {
      if (this.requisito.identificacao.split(' ')[0] == 'RNF') {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// TIPO REQUISITO.
      if (string === 'Restrição funcional') {
        return 'RESTRICAO_FUNCIONAL';
      } else if (string === 'Restrição organizacional') {
        return 'RESTRICAO_ORGANIZACIONAL';
      } else if (string === 'Restrição externa') {
        return 'RESTRICAO_EXTERNA';
      } else if (string === 'Restrição qualidade') {
        return 'RESTRICAO_QUALIDADE';
      }
    },
    converterEnumParaTexto(string) {
      /// TIPO REQUISITO.
      if (string === 'RESTRICAO_FUNCIONAL') {
        return 'Restrição funcional';
      } else if (string === 'RESTRICAO_ORGANIZACIONAL') {
        return 'Restrição organizacional';
      } else if (string === 'RESTRICAO_EXTERNA') {
        return 'Restrição externa';
      } else if (string === 'RESTRICAO_QUALIDADE') {
        return 'Restrição qualidade';
      }
    },
    /**
     * Controla a visibilidade do modal que mostra detalhes da dependência.
     */
    toggleShowDialogDep() {
      this.showDialogDep = !this.showDialogDep;
    },

    /**
     * Insere o conteúdo dentro do modal que mostra detalhes da dependência.
     *
     * @param {Object} conteudo Informações sobre a dependência.
     */
    setConteudoModalDep(conteudo) {
      this.conteudoModalDep = conteudo;
    },

    /**
     * Controla a visibilidade do modal que mostra detalhes da dependência e
     * insere esses detalhes dentro do modal.
     *
     * @param {Object} conteudo Informações sobre a dependência.
     */
    toggleDep(conteudo) {
      this.toggleShowDialogDep();
      this.setConteudoModalDep(conteudo);
    },
    /**
     * Faz uma requisição HTTP para excluir o requisito.
     */
    async deleteRequisito() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.patch(
          `${apiUrl}/api/v1/requisitos/${this.reqID}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.$toast.success(response.data.msg);
        this.showDialog = false;
        this.$router.go(-1);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Faz uma requisição HTTP para obter o requisito.
     */
    async getRequisito() {
      this.isLoading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/${this.reqID}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisito = response.data[0];

        console.log(this.requisito);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Faz uma requisição HTTP para obter a fonte do requisito.
     */
    async getFonte() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/${this.reqID}/fonte`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.fonteRequisito = response.data;
        this.fonteNome =
          this.fonteRequisito.tipo_fonte == 'EXTERNO'
            ? ': ' + this.fonteRequisito.tb_stakeholder_externo.nome
            : ': ' + this.fonteRequisito.tb_usuario.nome;
        if (this.fonteRequisito != null) {
          this.tipoFonte = this.fonteRequisito.tipo_fonte;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.wrapper-buttons {
  display: flex;
  justify-content: end;
}
.depItem {
  font-weight: bold;
  font-size: 12px;
  padding-bottom: 4px;
  padding-left: 0.5rem;
  padding-top: 4px;
  border-radius: 2px;
  margin-left: 1rem;
  overflow-y: auto;
  /* border-bottom: 1px solid grey; */
}

.depItem:hover {
  background-color: rgba(156, 156, 156, 0.756);
  cursor: pointer;
}
.middleLine {
  width: 1px;
  background-color: grey;
}

.conteinerDep {
  height: 200px;
  overflow-y: scroll;
}

.mydivider {
  height: 2px;
}
</style>
